import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appMilesFormat]'
})
export class MilesFormatDirective {

  constructor(private ctrl: NgControl) { }

  @HostListener('input', ['$event'])
  onKeyUp(event: Event) {
    const milestOriginal = this.ctrl.value;
    const milesFormat = this.transform(milestOriginal);
    if (milestOriginal !== milesFormat) {
      if (milestOriginal.length > 11) {
        event.stopPropagation();
      } else {
        this.ctrl.control.setValue(milesFormat);
        event.stopPropagation();
      }
    }
  }
  transform(value: string): string {
    const valueReturn = value
    .replace(/[^0-9]/g, '')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.') ;
    return valueReturn;
}

}
